import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import type { UserProfileCardData } from '../common-ui-components-user-profile-card/common-ui-components-user-profile-card.component';

@Injectable({
  providedIn: 'root'
})
export class UserHoverCardService {
  private cardDataSubject = new BehaviorSubject<UserProfileCardData | null>(null);
  private positionSubject = new BehaviorSubject<{ x: number; y: number }>({ x: 0, y: 0 });
  private lastHideTimestamp = 0;
  // AG Grid cell destruction can fire mouseenter on new cells before hideCard propagates.
  // This debounce window prevents stale events from re-showing the card.
  private readonly BLOCK_DURATION_MS = 10;

  cardData$ = this.cardDataSubject.asObservable();
  position$ = this.positionSubject.asObservable();

  showCard(data: UserProfileCardData, x: number, y: number): void {
    const timeSinceHide = Date.now() - this.lastHideTimestamp;
    if (timeSinceHide < this.BLOCK_DURATION_MS) {
      return;
    }
    this.cardDataSubject.next(data);
    this.positionSubject.next({ x, y });
  }

  updatePosition(x: number, y: number): void {
    this.positionSubject.next({ x, y });
  }

  hideCard(): void {
    this.lastHideTimestamp = Date.now();
    this.cardDataSubject.next(null);
  }
}
